"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewAs = void 0;
const Log_1 = __importDefault(require("@common/Log"));
class ViewAs {
    static target() {
        try {
            const value = sessionStorage.getItem(ViewAs.KEY);
            return value === null || value === "" ? null : value;
        }
        catch (err) {
            Log_1.default.warn("ViewAs::target() - sessionStorage unavailable: " + err.message);
            return null;
        }
    }
    static isActive() {
        return ViewAs.target() !== null;
    }
    static label() {
        var _a;
        try {
            return (_a = sessionStorage.getItem(ViewAs.LABEL_KEY)) !== null && _a !== void 0 ? _a : ViewAs.target();
        }
        catch (_b) {
            return ViewAs.target();
        }
    }
    static start(personId, label) {
        Log_1.default.info("ViewAs::start( " + personId + " )");
        sessionStorage.setItem(ViewAs.KEY, personId);
        sessionStorage.setItem(ViewAs.LABEL_KEY, label);
    }
    static stop() {
        Log_1.default.info("ViewAs::stop()");
        sessionStorage.removeItem(ViewAs.KEY);
        sessionStorage.removeItem(ViewAs.LABEL_KEY);
    }
    static addHeader(headers) {
        const target = ViewAs.target();
        if (target !== null) {
            headers[ViewAs.HEADER] = target;
        }
        return headers;
    }
    static renderBanner(onExit) {
        const existing = document.querySelector("#viewAsBanner");
        if (ViewAs.isActive() === false) {
            if (existing !== null) {
                existing.remove();
            }
            return;
        }
        if (existing !== null) {
            return;
        }
        const banner = document.createElement("div");
        banner.id = "viewAsBanner";
        banner.style.position = "fixed";
        banner.style.top = "0";
        banner.style.left = "0";
        banner.style.right = "0";
        banner.style.zIndex = "10000";
        banner.style.backgroundColor = "#b00020";
        banner.style.color = "white";
        banner.style.padding = "0.6em 1em";
        banner.style.fontSize = "smaller";
        banner.style.display = "flex";
        banner.style.justifyContent = "space-between";
        banner.style.alignItems = "center";
        const text = document.createElement("span");
        text.innerHTML = "<b>Viewing as " + ViewAs.label() + ".</b> You are acting as this user; anything you do here is real.";
        const exit = document.createElement("button");
        exit.id = "viewAsExitButton";
        exit.textContent = "Return to admin";
        exit.style.marginLeft = "1em";
        exit.onclick = () => {
            ViewAs.stop();
            onExit();
        };
        banner.appendChild(text);
        banner.appendChild(exit);
        document.body.appendChild(banner);
        document.body.style.paddingTop = banner.offsetHeight + "px";
    }
}
exports.ViewAs = ViewAs;
ViewAs.KEY = "viewAs";
ViewAs.LABEL_KEY = "viewAsLabel";
ViewAs.HEADER = "x-classy-view-as";
